<app-pagetoolbar label="Recipient - Approvals" icon="group"></app-pagetoolbar>
<mat-accordion multi="false">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filter recipient approval</mat-label>
      <input matInput [formControl]="searchControl" placeholder="Type to filter..." />
      <button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [formControl]="_filterButtons" appearance="legacy">
      <mat-button-toggle value="all">Show All</mat-button-toggle>
      <mat-button-toggle value="pending">Show Pending</mat-button-toggle>
      <mat-button-toggle value="approved">Show Approved</mat-button-toggle>
      <mat-button-toggle value="denied">Show Denied</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-expansion-panel *ngFor="let approval of filteredApprovals" class="pair">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b class="random-number"> <span [innerHTML]="approval.recipient.enisNumber | highlight: searchControl.value || ''"></span></b>
        <span class="ellipsis-container participant-name">
          <span
            *ngIf="approval.recipient.firstName || approval.recipient.lastName; else showRecipientDob"
            [innerHTML]="(approval.recipient.firstName || '') + ' ' + (approval.recipient.lastName || '') | highlight: searchControl.value || ''"
          ></span>
          <ng-template #showRecipientDob> <span [innerHTML]="approval.recipient.dob | highlight: searchControl.value || ''"></span> </ng-template>
        </span>
      </mat-panel-title>
      <mat-panel-description> {{ approval?.recipient?.center?.name || 'N/A' }} </mat-panel-description>
      <mat-panel-description> {{ approval?.status | titlecase }} </mat-panel-description>
      <mat-panel-description> {{ approval?.dateCreated | date: "d MMM y, HH:mm" }} </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-container>
      <div class="participant-boxes separator-bottom responsive-layout">
        <div class="inactive-reason" *ngIf="approval?.status === ApprovalStatus.DENIED">Denied with reason: {{ approval?.closedReason }}</div>
        <app-approval-box [approval]="approval"> </app-approval-box>
      </div>
    </ng-container>

    <mat-action-row *ngIf="updateApprovals || canDeleteApproval">
      <button *ngIf="canDeleteSpecificApproval(approval)" mat-button color="warn" (click)="deleteApproval(approval)">Delete</button>
      <button *ngIf="updateApprovals && approval?.status === ApprovalStatus.PENDING" mat-button class="warn-button" (click)="denyApproval(approval)">Deny <br /></button>
      <button *ngIf="updateApprovals && approval?.status === ApprovalStatus.PENDING" mat-button class="custom-button" (click)="approve(approval)">Approve <br /></button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>

<div class="rowcount">showing {{ filteredApprovals.length }} of {{ approvals.length }} approval requests</div>
